import { I18n } from 'react-redux-i18n';

import { api, mergeParams, wrapParams } from '../../../api';
import { SHOW_LOADING, HIDE_LOADING } from '../types/loadingTypes';

import { showToast } from '../toastrActions';

export function dashboard(holdingID) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    return new Promise((resolve, reject) => {

      api.get('Dashboard/Dashboard', { params: { holdingID } }).then((response) => {

        dispatch({
          type: HIDE_LOADING,
        });

        showToast('success', '', 'Notas Carregadas com sucesso')
        resolve(response.data.return);

      }, (error) => {

        dispatch({
          type: HIDE_LOADING,
        });

        showToast('error', '', 'Ocorreu um erro ao carregar as notas salvas')

        reject(error.response.data.return);

      });

    });

  };

}



// WEBPACK FOOTER //
// ./src/redux/actions/tracker/dashboardActions.js